import { render } from "./DashboardChat.vue?vue&type=template&id=2a5a9a8c&scoped=true&ts=true"
import script from "./DashboardChat.vue?vue&type=script&lang=ts"
export * from "./DashboardChat.vue?vue&type=script&lang=ts"

import "./DashboardChat.vue?vue&type=style&index=0&id=2a5a9a8c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5a9a8c"]])

export default __exports__